import { Config } from "src/models";
import { ConfigInit, ConfigInitInitialState, ReduxAction } from "../models";
import { ConfigInitTypes } from "../types";

export const ConfigState = (state: ConfigInit = ConfigInitInitialState, action?: ReduxAction): ConfigInit => {
    if (!action) return state;

    switch (action.type) {
        case ConfigInitTypes.SHOW_CONFIG_INIT_LOADING:
        case ConfigInitTypes.REQUEST_LOAD_CONFIG_INIT:
            return { ...state, loading: true };
        case ConfigInitTypes.HIDE_CONFIG_INIT_LOADING:
            return { ...state, loading: false };
        case ConfigInitTypes.SET_CONFIG_INIT_DATA:
            const data: Config = action.payload;
            const config = state.config;

            return {
                ...state,
                loading: false,
                loaded: !!data,
                config: {
                    appSetting: {
                        ...config.appSetting,
                        ...data.appSetting,
                        activeTabs: [...data.appSetting.activeTabs]
                    },
                    logos: {
                        ...config.logos,
                        ...data.logos
                    }
                }
            };
    }

    return state;
};

